import Navbar from "@/components/Navbar";

const Terms = () => {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <div className="container mx-auto px-4 pt-32 pb-16">
        <div className="max-w-4xl mx-auto bg-black/40 backdrop-blur-md rounded-lg p-8 text-white">
          <h1 className="text-3xl md:text-4xl font-bold text-center mb-8 text-[#FF3366]">
            GridBot & DeFi Mastery — Terms & Refund Policy
          </h1>
          
          <div className="text-sm text-gray-400 mb-6">
            Version: v2025-08-20
          </div>

          <div className="space-y-8 text-gray-300 prose prose-invert max-w-none">
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">Summary (readable top paragraph)</h2>
              <p className="mb-4">
                Orientation + Module 1 are available immediately. Advanced modules, templates, and replays unlock on Day 8. You can request a change-of-mind refund within 7 days only if you have not accessed members-only content. Your local consumer protections still apply:
              </p>
              <p className="mb-2">
                <strong>EU/UK:</strong> 14-day cancellation for digital content unless you ask for immediate access and acknowledge you'll lose that right; if you don't consent, you keep the 14 days.
              </p>
              <p className="mb-2">
                <strong>Saudi Arabia:</strong> 7-day termination if you have not benefited from the service/product (plus a 15-day delay trigger).
              </p>
              <p>
                <strong>US:</strong> The FTC "Cooling-Off Rule" does not apply to online sales; our voluntary policy above governs.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">1) Who we are</h2>
              <p>
                GridBot & DeFi Mastery is provided by MYZ TRADING LTD a company registered in England and Wales (company number 13227060). Registered address: 71-75 Shelton St, Covent Garden, London, WC2H 9JQ, England. Contact: team@gridbotdefi.com
              </p>
              <p className="mt-2">
                This Course is educational content delivered online (no asset custody).
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">2) Access model</h2>
              <p><strong>Immediate:</strong> Orientation + Module 1.</p>
              <p><strong>Day 8:</strong> Advanced modules, templates, and replays unlock (unless you are within a statutory cooling-off period you chose not to waive).</p>
              <p className="mt-2">We may watermark and monitor access to deter piracy.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">3) Refunds & cooling-off (how it works in practice)</h2>
              <p className="mb-2">
                <strong>Our voluntary policy (global):</strong> 7-day change-of-mind refunds only if you have not accessed members-only content (advanced modules, downloads, replays).
              </p>
              <p className="mb-2">
                <strong>EU/UK buyers:</strong> You have a 14-day cancel right for digital content supplied online unless you ask for immediate access and acknowledge you'll lose that right once access begins. If you don't give that consent, we'll delay advanced access until Day 15 or until you consent.
              </p>
              <p className="mb-2">
                <strong>KSA buyers:</strong> You may terminate within 7 days if you haven't benefited from the service/content; you also may cancel if delivery/performance is delayed beyond 15 days (unless a different period is agreed).
              </p>
              <p className="mb-2">
                <strong>US buyers:</strong> No federal cooling-off for online purchases; our voluntary 7-day policy applies in addition to any state consumer laws.
              </p>
              <p>
                <strong>How to request:</strong> email team@gridbotdefi.com within the applicable window. Refunds process within 7 business days after approval.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">4) License & IP</h2>
              <p>
                Personal, non-transferable license. No redistribution, resale, public posting, screen-recording, or sharing of materials. We may watermark materials with your name/email/order ID and limit concurrent sessions.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">5) Education-only</h2>
              <p>Nothing here is financial, tax, or legal advice. Markets carry risk. Results vary and are not guaranteed.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">6) Your responsibilities</h2>
              <p>
                You're responsible for your exchange accounts, KYC, banking/fiat routes, fees, taxes, and compliance in your jurisdiction.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">7) Service issues & faulty content</h2>
              <p>
                If content is faulty or mislabeled, tell us and we'll repair, replace, or refund as required by applicable law (EU/UK digital-content rights apply; you must refrain from using/resharing withdrawn digital content).
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">8) Governing law, venue & mandatory local rights</h2>
              <p className="mb-2">
                <strong>Governing law & venue:</strong> These Terms are governed by England & Wales, and disputes may be brought in the courts of England & Wales.
              </p>
              <p className="mb-2">
                <strong>Mandatory rights preserved:</strong> If you are a consumer resident in the EU/UK, KSA, or US, any mandatory consumer protections in your home jurisdiction also apply and prevail in case of conflict (e.g., EU/UK 14-day digital-content rules; KSA 7-day "no benefit" rule).
              </p>
              <p>Consumers may also bring claims in their local courts where required by mandatory law.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">9) Changes & versioning</h2>
              <p>We version these Terms and record acceptance. Current version: v2025-08-20.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">10) Contact</h2>
              <p>team@gridbotdefi.com</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;